import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { BADGE_IMAGE_DATA_MAP } from '../../services/badge';

const ShieldLabel = ({ showOne, assessmentBadge, isNextGenBlue }: { showOne: boolean, assessmentBadge?: any, isNextGenBlue: boolean }) => {
  const blueBadgeObject = isNextGenBlue ? BADGE_IMAGE_DATA_MAP.blueNextGen : BADGE_IMAGE_DATA_MAP.blue;
  return (
    <Box
      sx={{ 
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: 'space-between',
      }}>
      {/* Blue Badge or Placeholder */}
      {showOne ? (
        <Tooltip title={blueBadgeObject.label} arrow placement="top">
          <img
            src={blueBadgeObject.src}
            alt={blueBadgeObject.alt}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: '1px solid #ddd',
              padding: { isNextGenBlue: '6px', default: '4px' }[isNextGenBlue ? 'isNextGenBlue' : 'default'],
              backgroundColor: '#fff',
              overflow: 'visible',
            }}
          />
        </Tooltip>
      ) : (
        <Box sx={{ width: '40px' }}/>
      )}

      {/* Gold Badge or Placeholder */}
      {assessmentBadge ? (
        <Tooltip title={assessmentBadge.label} arrow placement="top">
          <img
            src={assessmentBadge.src}
            alt={assessmentBadge.alt}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: '1px solid #ddd',
              padding: '4px',
              backgroundColor: '#fff',
            }}
          />
        </Tooltip>
      ) : (
        <Box sx={{ width: '40px' }}/>
      )}
    </Box>
  );
};

export default ShieldLabel;
